export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setProduct(state, product) {
    if (product) {
      state.product = {
        ...product,
        pixel: product && product.pixel ? product.pixel : []
      };
    } else {
      state.product = null;
    }
  },
  setNewProduct(state, new_product) {
    state.newProduct = new_product;
  },
  setProducts(state, products) {
    state.products = products;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setCurrencies(state, currencies) {
    state.currencies = currencies;
  },
  setPaymentMethods(state, paymentMethods) {
    state.paymentMethods = paymentMethods;
  },
  setCoupons(state, coupons) {
    state.coupons = coupons;
  },
  setCoupon(state, coupon) {
    state.coupon = coupon;
  }
};
